import { useKitbagAuth } from '@statsbomb/kitbag-auth';

export const useLogout = () => {
  const { logout } = useKitbagAuth();

  return () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };
};
